import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
	type GenerateQuoteOptions,
	type GenerateQuoteResponse,
	httpGenerateQuote
} from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { QUOTE_GENERATION_LISTINGS_QUERY_KEY } from './use-get-quote-generation-listings'

export const useGenerateQuote = (
	options?: Omit<
		UseMutationOptions<
			GenerateQuoteResponse,
			unknown,
			GenerateQuoteOptions
		>,
		'mutationFn'
	>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (params) => httpGenerateQuote(params),
		...options,
		onSuccess: (...args) => {
			queryClient.invalidateQueries({
				queryKey: [QUOTE_GENERATION_LISTINGS_QUERY_KEY]
			})
			options?.onSuccess?.(...args)
		},
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		}
	})
}
